import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../config/settings";
import httpRequest from "../../utils/httpRequest";
import { objToParams } from "../../utils/func";

const initialState = {
  loading: false,
  error: null,
  individuals: [],
  individualDetails: "",
  feePaymentDetail: "",
  feepaymentId: "",
  paymentConfirmation: false,
  individualsParams: {
    status: "Pending",
    page: 1,
    pageSize: 5,
  },
};

export const fetchIndividualApplicationApproval = createAsyncThunk(
  "individualApplicationApproval/fetchIndividualApplicationApproval",
  async (arg, { getState }) => {
    return httpRequest(
      `${BASE_URL}/v2/Application/all-individual-applications${objToParams(
        getState()?.individualApplicationApproval?.individualsParams
      )}`
    );
  }
);

export const fetchIndividualDetails = createAsyncThunk(
  "individualApplicationApproval/fetchIndividualDetails",
  async (id) => {
    return httpRequest(`${BASE_URL}/v2/Application/${id}/individual-details`);
  }
);

export const approveIndividualApplication = createAsyncThunk(
  "individualApplicationApproval/approveIndividualApplication",
  async (arg, { rejectWithValue }) => {
    try {
      const response = await httpRequest(
        `${BASE_URL}/v2/Application/approve-individual`,
        "post",
        arg
      );
      if (response?.response?.data) {
        throw response;
      }
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

const individualApplicationApprovalSlice = createSlice({
  name: "individualApplicationApproval",
  initialState,
  reducers: {
    setIndividualDetails: (state, { payload }) => {
      state.individualDetails = payload;
    },
    setFeePaymentDetail: (state, { payload }) => {
      state.feePaymentDetail = payload;
    },
    setFeepaymentId: (state, { payload }) => {
      state.feepaymentId = payload;
    },
    setPaymentConfirmation: (state, { payload }) => {
      state.paymentConfirmation = payload;
    },
    setUpdateIndividualsStatus: (state, { payload }) => {
      state.individualsParams.status = payload;
      state.individuals = [];
    },
    setUpdateIndividualsPagination: (state, { payload }) => {
      state.individualsParams.page = payload;
      state.individuals = [];
    },
    setUpdateIndividualsPageSize: (state, { payload }) => {
      state.individualsParams.pageSize = payload;
      state.individuals = [];
    },
  },
  extraReducers: (builder) => {
    //  get individual applications:
    builder.addCase(fetchIndividualApplicationApproval.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      fetchIndividualApplicationApproval.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.individuals = payload;
        state.error = null;
      }
    );
    builder.addCase(
      fetchIndividualApplicationApproval.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );

    //  get individual details:
    builder.addCase(fetchIndividualDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchIndividualDetails.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.individualDetails = payload;
      state.error = null;
    });
    builder.addCase(fetchIndividualDetails.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = payload?.error?.description;
    });

    //  approve individual application:
    builder.addCase(approveIndividualApplication.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      approveIndividualApplication.fulfilled,
      (state, { payload }) => {
        state.loading = false;
        state.error = null;
      }
    );
    builder.addCase(
      approveIndividualApplication.rejected,
      (state, { payload }) => {
        state.loading = false;
        state.error = payload?.error?.description;
      }
    );
  },
});

export const {
  setIndividualDetails,
  setFeePaymentDetail,
  setFeepaymentId,
  setPaymentConfirmation,
  setUpdateIndividualsStatus,
  setUpdateIndividualsPagination,
  setUpdateIndividualsPageSize,
} = individualApplicationApprovalSlice.actions;
export default individualApplicationApprovalSlice.reducer;
